module.exports = __webpack_public_path__ + "assets/cbaoxiao.38dc436887e5bfd12baf9b9c57786f68.png";